<template>
  <v-container mt-10>
    <v-row>
      <v-col cols="12">
        <h1>{{ $t('errors.404.title')}}</h1>
      </v-col>
      <v-col cols="8">
        <h2>{{ $t('errors.404.lead')}}</h2>
        <p>{{ $t('errors.404.text')}}</p>

        <v-btn
          outlined
          class="rounded-0"
          height="47"
          to="/"
        >
          {{ $t('errors.404.cta') }}
        </v-btn>
      </v-col>
      <v-col cols="4">
        <img
          src="https://www.lausanne-tourisme.ch/app/themes/bwap-theme/images/icon_bateau-cgn.png"
          :alt="$t('errors.404.image-label')"
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'NotFoundPage',

    async mounted() {
      const { path } = this.$route.params
      if (!path) return


      await this.$router.push({ path })

      // reload page because the component isn't showing when there is a redirection
      // @TODO find a better way to handle 404 and locale together
      window.location.reload()
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"
  @import "@/assets/styles/_mixins.sass"

  h1
    text-transform: uppercase
    font-size: 3rem

  h2
    font-size: 1.8rem
    margin: 1em 0

  .v-btn
    @include basic-btn
    margin-top: 10px

</style>
